import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class MetaService {
  constructor(
    private title: Title,
    private meta: Meta
  ) {}

  mainTitle = 'Myescort.dk';
  private makeTitle(title: string) {
    return `${title} | ${this.mainTitle}`;
  }

  setTitle(title: string) {
    if (title) {
      this.title.setTitle(title);
    }
  }

  updateTitle(title: string) {
    if (title) {
      this.title.setTitle(this.makeTitle(title));
    }
  }

  updateDescription(description: string) {
    if (description) {
      this.meta.updateTag({ name: 'description', content: description });
    }
  }
}
